import $ from 'jquery';
import _ from 'lodash';
import { getLanguage } from '../utils/language';
import HeaderProps from './header/_header-props';

const selectors = {
	input: '[data-search-field]',
	dropdown: '[data-search-results]',
}

export default class Search {
	constructor() {
        this.activeKeyWords = null;

		const element = $(selectors.input);
		element.on('keyup',
			_.debounce((event) => this.onKeyup(event), 200, true)
		);

        // check if the window size is mobile
        const isMobile = matchMedia(
            `(max-width: ${HeaderProps.breakPoint})`,
        ).matches;

		// Remove content on click outside input field
        if (!isMobile) {
            element.on('blur', () => {
                element.val('');
                this.currentData = [];
                this.lastData = [];
                this.clearSearchResults();
            });
        }
	}

    clearSearchResults() {
        $('body').removeClass('u-prevent-scroll--non-fixed');
        $('.c-header').removeClass('c-header--search-open');

        const $dropdown = $(selectors.dropdown);

        if ($dropdown[0].innerHTML.replace(/\s/g, '') === '') {
            return;
        }

        const $listTransition = $dropdown[0]?.closest('[data-list-transition]');
        const clear = () => {
            $listTransition.removeEventListener('list-closed', clear);
            setTimeout(() => {
                $dropdown.html('');
            }, 500);
        }
        $listTransition?.addEventListener('list-closed', clear);
        $listTransition?.setTransitionOut();
    }

	/*
	 * onKeyup
	 * User types in input field
	 */
	onKeyup(event) {
		const element = $(event.target);
		const dropdown = $(selectors.dropdown);
		const keywords = element.val();

		if (keywords.length > 2) {
            this.activeKeyWords = keywords;
			$.when(this.getData(keywords))
				.done(this.updateDropdown.bind(this, dropdown));

            window.dataLayer.push({
                'event': 'search',
                'search_type': 'main',
                'search_query': this.activeKeyWords,
            });
		} else {
            this.updateDropdown(dropdown, null);
        }

		// Easter
		if (btoa(keywords) === 'anVuaW9yIHZhbiBkZXIgc3RlbA==') {
			const a = '-webkit-', b = 'transform:rotate(1turn);', c = 'transition:4s;';
			document.head.innerHTML += '<style>body{' + a + b + a + c + b + c;
		}
	}

    shouldUpdateDropdown(currentData, lastData){
        if (!lastData) {
            return true;
        }

        const sameLength = currentData.length === lastData.length;
        if (!sameLength) {
            return true;
        }

        if (currentData.length === 0) {
            return false;
        }

        return currentData[0].Name !== lastData[0].Name;
    }

    onDropdownTransitionEnd($transitionList, dropdown){
        $transitionList.removeEventListener('list-closed', this.listenerToBeRemoved);
        this.printResults(dropdown, this.currentData);
    }
    updateDropdown(dropdown, data) {
        if (data === null) {
            this.currentData = [];
        } else {
            this.currentData = this.transformData(data);
        }

        if (this.shouldUpdateDropdown(this.currentData, this.lastData)) {
            const $transitionList = dropdown[0]?.closest('[data-list-transition]');

            // if no transition list was found, then just update the data
            if (!$transitionList) {
                this.printResults(dropdown, this.currentData);
            }

            //otherwise first close the current results list and then update the data
            this.listenerToBeRemoved = this.onDropdownTransitionEnd.bind(this, $transitionList, dropdown);
            $transitionList.addEventListener('list-closed', this.listenerToBeRemoved);
            $transitionList.setTransitionOut();
            this.lastData = this.currentData;
        }
    }

	/*
	 * getData
	 * Get data from API
	 */
	getData(keywords) {
		// Get new results
		return $.ajax({
			url: `/api/searchservice.asmx/SearchShows`,
			type: 'GET',
			contentType: 'application/json; charset=utf-8',
			data: {
				keywords: `"${keywords}"`,
				language: `"${getLanguage()}"`
			},
			dataType: 'json',
			success: function(data) {return data},
		});
	}

    transformData(data){
        const items = [];
        data.d.Items.forEach((item) => {
            item.Results.forEach((result) => {
                items.push({
                    ...result,
                    Year: item.Name,
                });
            });
        });
        return items;
    }

	/*
	 * printResults
	 * Print results in DOM
	 */
	printResults($dropdown, items) {
        if (items.length > 0) {

            $('body').addClass('u-prevent-scroll--non-fixed');
            $('.c-header').addClass('c-header--search-open');

			const $ul = $('<ul class="c-search-results__list o-list-clean" />');
            let currentYear = null;

			items.forEach((item) => {
				const $li = $('<li class="o-list-transition__item" data-list-transition-item />');
                const $itemContainer = $(`<a class="c-search-results__item" href="${item.Url}" 
                    onclick="window.dataLayer.push(
                        {
                            'event': 'search_suggestion',
                            'action': 'action',
                            'search_query': this.activeKeyWords,
                            'search_suggestion': show.Name,
                        }
                    )" />`)

                if (currentYear !== item.Year) {
                    $itemContainer.append(this.printYear(item.Year));
                    currentYear = item.Year;
                } else {
                    $itemContainer.append('<span class="c-search-results__same-year"></span>');
                }

                $itemContainer.append(this.printShow(item));

                $li.append($itemContainer);
				$ul.append($li);
			})

			$dropdown.html($ul);

            Search.setTransitionIn($dropdown[0]);
		}
	}

    static setTransitionIn($dropdown){
        const $listTransition = $dropdown.closest('[data-list-transition]');
        $listTransition.setMaxHeightOnContainers();
        $listTransition.setTransitionIn();
        return $listTransition;
    }

	/*
	 * printYear
	 */
	printYear(year) {
        year = year.replace(/^[0-9]{2}([0-9]{2})$/g, '\'$1');
        const html = `<span class="c-search-results__year"> ${year} </span>`
		return $(html.replace(/\t{4,}/g, ''));
	}

	/*
	 * printShow
	 */
	printShow(show) {
        return $(`<span class="c-search-results__show"><span class="c-button c-button--link-inline">${show.Name}</span></span>`);
	}
}

/*
 * Create a new Search() instance
 */
new Search();
